import {gsap} from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin( ScrollTrigger)



// ******************
// Selectors
// ******************
const pageTitle = document.querySelector('.voz--mainCol__title')
const mainDescription = document.querySelector('.voz--mainCol__description')
const ctaButton = document.querySelector('.ctaButton')
const heroImg = document.getElementById('heroImg')
const benefitsSection = document.querySelector('.vos--benefitsCol')
const benefitsTitle = document.querySelector('.voz--benefitsCol__title')
const benefitsBar = document.querySelector('.voz--benefitsCol__bar')
const benefits = document.querySelectorAll('.voz--benefitsCol__item')


// ***************
// Title animation
// ***************
window.addEventListener('load', () => {
  if(window.innerWidth <= 768) {
    const titleAnimation = gsap.timeline()
    .from({}, {duration: 1})
    .from(pageTitle, {y: '50%', opacity: 0})
    .from(mainDescription, {y: 30, opacity: 0}, '-=.4')
    .from(ctaButton, {x: -50, opacity: 0, ease: 'back'}, '-=.3')
    .from(heroImg, {y: 50, opacity: 0}, '<')
  } else {
    // console.log('big')
    const titleAnimation = gsap.timeline()
    .from({}, {duration: 1})
    .from(pageTitle, {y: '50%', opacity: 0})
    .from(mainDescription, {y: 30, opacity: 0}, '-=.4')
    .from(ctaButton, {x: -50, opacity: 0, ease: 'back'}, '-=.3')
    .from(heroImg, {y: 50, opacity: 0}, '<')
    .from(benefitsTitle, {y: 30, opacity: 0}, '<')
    .from(benefitsBar, {scaleX: 0}, '-=.3')
    .from([benefits], {x: 100, opacity: 0, stagger: 0.2}, '<')
  }
})


// ************************
// Benefits phone animation
// ************************
if(window.innerWidth <= 768) {
  console.log('benefitsTitle: ', benefitsTitle)
  const benefitTitleAnimation = gsap.timeline({
    scrollTrigger: {
      trigger: benefitsTitle,
      start: 'top 70%'
    }
  })
  .from(benefitsTitle, {y: 30, opacity: 0})
  .from(benefitsBar, {scaleX: 0, duration : 1}, '<')


  benefits.forEach((benefit) => {
    const header = benefit.querySelector('.voz--benefitsCol__item-header')
    const body = benefit.querySelector('.voz--benefitsCol__item-body')

    const benefitAnimation = gsap.timeline({
      scrollTrigger: {
        trigger: benefit,
        start: 'top 70%'
      }
    })
    .from(header, {x: -100, opacity: 0, ease: 'back'})
    .from(body, {y: 20, opacity: 0}, '-=.3')

  })


}
